import type { StampDutyRuleSet } from "./types.js";

// VIC land transfer (stamp) duty — current rates (non-PPR general scale).
//
// Transcribed VERBATIM from SRO Victoria "Land transfer duty — non-PPR current
// rates" (fetched 2026-06-22 — stamp-duty-calculator-figures.md Fig 5):
//
//   $0          – $25,000     : 1.4% of dutiable value
//   $25,001     – $130,000    : $350     + 2.4% over $25,000
//   $130,001    – $960,000    : $2,870   + 6%   over $130,000
//   $960,001    – $2,000,000  : 5.5% of the WHOLE dutiable value (flat band)
//   $2,000,001  and over      : $110,000 + 6.5% over $2,000,000
//
// Worked example (ledger): $1,000,000 sits in the flat 5.5% band →
//   $1,000,000 × 5.5% = $55,000.  ($800,000 → $2,870 + 6% × $670,000 = $43,070.)
// Both CITED exact against SRO.
//
// Foreign Purchaser Additional Duty (FPAD): 8%, contracts on/after 1 Jul 2019
// (Fig 6, CITED).
//
// First-home buyer duty exemption/concession (first-home ledger Fig 2, CITED):
//   exempt (nil) up to $600,000; sliding-scale concession $600,001–$750,000;
//   full duty above $750,000. SRO sliding-scale formula:
//     concessional duty = generalDuty × (dutiableValue − $600,000) ÷ $150,000.

export const vic2025_26: StampDutyRuleSet = {
  state: "VIC",
  period: "2025-26",
  effectiveFrom: "2025-07-01",
  effectiveTo: "2026-06-30",
  sources: {
    transferDuty:
      "https://www.sro.vic.gov.au/about-us/rates-and-statistics/current-rates/land-transfer-duty-non-principal-place-residence-current-rates",
    foreignSurcharge:
      "https://www.sro.vic.gov.au/about-us/rates-and-statistics/current-rates/foreign-purchaser-additional-duty-current-rates",
    firstHome:
      "https://www.sro.vic.gov.au/buying-property/land-transfer-stamp-duty/concessions-exemptions-and-waivers/first-home-buyers/first-home-buyer-duty-exemption-or-concession",
  },
  sourcesVerifiedAt: "2026-06-22",
  brackets: [
    { from: 0, to: 25_001, base: 0, rate: 0.014, over: 0 },
    { from: 25_001, to: 130_001, base: 350, rate: 0.024, over: 25_000 },
    { from: 130_001, to: 960_001, base: 2_870, rate: 0.06, over: 130_000 },
    // Flat 5.5% of the WHOLE dutiable value (not marginal).
    { from: 960_001, to: 2_000_001, base: 0, rate: 0.055, over: 0, wholeValue: true },
    { from: 2_000_001, to: null, base: 110_000, rate: 0.065, over: 2_000_000 },
  ],
  foreignSurchargeRate: 0.08,
  foreignSurchargeFrom: "2019-07-01",
  firstHome: {
    fullExemptionUpTo: 600_000,
    taperEndsAt: 750_000,
    taper: "vic-linear",
  },
  firstHomeNewBuild: null,
};
